import React from "react";
import { T } from "../theme";

// The one status pill on the read-only client page. Tone, not meaning:
// neutral (scheduled, to start, planned) · live (in progress, current) ·
// good (done, paid) · attention (missed, to invoice) · bad (overdrawn).
const TONES = {
  neutral:   { bg: T.bgNeutral,    color: T.fgSecondary },
  live:      { bg: T.threadline,   color: T.root },
  good:      { bg: T.statusOnBg,   color: T.statusOn },
  attention: { bg: T.statusRiskBg, color: T.statusRisk },
  bad:       { bg: T.statusOffBg,  color: T.statusOff },
};

export default function Pill({ tone = "neutral", children }) {
  const s = TONES[tone] || TONES.neutral;
  return <span style={{ display: "inline-block", fontSize: 12, fontWeight: 600, lineHeight: 1.4, padding: "2px 10px", borderRadius: T.radiusPill, background: s.bg, color: s.color, whiteSpace: "nowrap", fontFamily: T.fontSans }}>{children}</span>;
}

export const STEP_TONE = { "to-start": ["neutral", "To start"], "in-progress": ["live", "In progress"], "complete": ["good", "Done"] };
export const INVOICE_TONE = { paid: ["good", "Paid"], sent: ["neutral", "Invoiced"], invoiced: ["neutral", "Invoiced"], part: ["attention", "Part invoiced"], pending: ["attention", "To invoice"] };
export const BILLED_TONE = { "to-invoice": ["attention", "To invoice"], invoiced: ["neutral", "Invoiced"], paid: ["good", "Paid"] };
